import { render, staticRenderFns } from "./ExamGrading.vue?vue&type=template&id=71565fb2&scoped=true"
import script from "./ExamGrading.vue?vue&type=script&lang=js"
export * from "./ExamGrading.vue?vue&type=script&lang=js"
import style0 from "./ExamGrading.vue?vue&type=style&index=0&id=71565fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71565fb2",
  null
  
)

export default component.exports